const { TextControl } = wp.components;

import "./style.scss";

const PanelItem = (props) => {
  const { title, onChange } = props;
  return (
    <div className="panelItem">
      {/* <PanelRow> */}
      <TextControl value={title} onChange={(title) => onChange(title)} {...props} />
      {/* </PanelRow> */}
    </div>
  );
};

export default PanelItem;
